import Ajv2020 from "ajv/dist/2020";
import addFormats from "ajv-formats";
import { AGENT_ACTIONS_SCHEMA_KEY } from "../model/fieldActionContext";

/**
 * Shared catalog AJV instance factory used by JSON Forms and section validation.
 *
 * Strict mode stays on, so the catalog's own vendor keywords are declared rather than
 * tolerated; `ajv-formats` supplies the `date` format the generated schema uses.
 */
export function createCatalogAjv(): Ajv2020 {
  const ajv = new Ajv2020({ allErrors: true, strict: true, verbose: true });
  addFormats(ajv);
  ajv.addVocabulary(["x-field-id", "x-collection-id", "x-followup-role", "x-codelist", "x-e2b", "x-validation-messages", "x-validation-config", "x-rule-id", "x-rule-message", "x-rule-fields", "x-rule-e2b", "x-server-rules", AGENT_ACTIONS_SCHEMA_KEY]);
  return ajv;
}

/**
 * The instance that evaluates a compiled rule's `if` fragment.
 *
 * <p>Lenient on purpose, and separately named so the difference is a decision rather than an
 * accident: a fragment is a condition lifted out of a schema, so it carries no `type` of its own
 * and strict mode rejects it. Validating a whole catalog schema still uses the strict instance
 * above — the vendor keywords there should be declared, not tolerated.
 */
export function createCatalogRuleAjv(): Ajv2020 {
  const ajv = new Ajv2020({ allErrors: true, strict: false });
  addFormats(ajv);
  return ajv;
}
